export class MacroCategoriaSal{
    id:number;
    titolo:string;  
}